<template>
  <pagefra
    v-loading.fullscreen="deriveLoading"
    element-loading-text="生成中..."
  >
    <div
      class="report-box"
      id="elevator-daily"
      :class="{ bigSize: deriveLoading }"
      v-loading.fullscreen="loading"
    >
      <div class="report-item-box">
        <div class="report-title">
          <div class="title-l">
            <label
              class="back"
              v-if="!deriveLoading"
              @click="$router.go(-1)"
              ><i class="el-icon-arrow-left"></i>{{ $l("返回") }}
            </label>
            <strong>{{ $l("电梯基本信息") }} </strong>
          </div>
          <div class="title-r">
            <el-button
              type="primary"
              round
              v-if="!params.reportId"
              @click="handleDefault"
              :loading="saveLoading"
              class="download"
              >{{ $l("一键确认") }}
            </el-button>
            <el-button
              type="primary"
              round
              v-if="!params.reportId"
              @click="handleSaveForm"
              :loading="saveLoading"
              >{{ $l("提交") }}
            </el-button>
            <el-button
              type="primary"
              round
              v-else-if="!deriveLoading"
              @click="handleDerive"
              class="download"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
        <div class="content-box">
          <div class="info-box">
            <div class="code-item">
              <span>{{ $l("所在城市：") }} {{ form.city }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("地盘名称：") }} {{ form.domainName }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("大楼名称：") }} {{ form.buildingName }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("梯号：") }} {{ form.elevatorNum }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("工号：") }} {{ form.jobNum }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("注册代码：") }} {{ form.registerCode }}</span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("报告确认时间：") }}
                {{
                  (form.confirmTime && form.confirmTime.split(" ")[0]) ||
                  params.confirmTime.split(" ")[0]
                }}</span
              >
            </div>
            <div class="code-item">
              <span class="ti-input" v-if="!deriveLoading"
                >{{ $l("电梯管理员：") }}

                <el-input
                  v-model="form.adminName"
                  :placeholder="deriveLoading ? '' : $l('请输入')"
                  maxlength="20"
                />
              </span>
              <span class="ti-input" v-else
                >{{ $l("电梯管理员：") }} {{ form.adminName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="report-item-box"
        v-if="
          isCodeShow('elevatorRunStatus') ||
          isCodeShow('elevatorInnerStatus') ||
          isCodeShow('elevatorOuterStatus') ||
          isCodeShow('estateRescueFacilityStatus')
        "
      >
        <div class="report-title">
          <div class="title-l">
            <strong>{{ $l("安全巡检结果") }} </strong>
            <span
              >{{ $l("系统生成时间：") }} {{ form.systemGenerateTime }}</span
            >
          </div>
          <div class="title-r"></div>
        </div>
        <div class="content-box">
          <div class="runstatus-box">
            <div class="runstatus-item" v-if="isCodeShow('elevatorRunStatus')">
              <div class="runstatus-section">
                <span>{{ $l("电梯设备运行状态：") }}</span>
                <el-select
                  v-model="form.elevatorRunStatus"
                  :placeholder="$l('请选择')"
                  :disabled="readonly"
                  :class="showClass(form.elevatorRunStatus, 3)"
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="item in normal"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="runstatus-item"
              v-if="isCodeShow('elevatorInnerStatus')"
            >
              <div class="runstatus-section">
                <span>{{ $l("电梯内部安全情况：") }}</span>
                <el-select
                  v-model="form.elevatorInnerStatus"
                  :placeholder="$l('请选择')"
                  :disabled="readonly"
                  :class="showClass(form.elevatorInnerStatus, 2)"
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="item in safety"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="runstatus-item"
              v-if="isCodeShow('elevatorOuterStatus')"
            >
              <div class="runstatus-section">
                <span>{{ $l("电梯外部安全情况：") }}</span>
                <el-select
                  v-model="form.elevatorOuterStatus"
                  :placeholder="$l('请选择')"
                  :disabled="readonly"
                  :class="showClass(form.elevatorOuterStatus, 2)"
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="item in safety"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="runstatus-item"
              v-if="isCodeShow('estateRescueFacilityStatus')"
            >
              <div class="runstatus-section">
                <span>{{ $l("小区应急救援设施情况：") }}</span>
                <el-select
                  v-model="form.estateRescueFacilityStatus"
                  :placeholder="$l('请选择')"
                  :disabled="readonly"
                  :class="showClass(form.estateRescueFacilityStatus, 3)"
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="item in normal"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-box">
        <div class="section-l">
          <div class="flex-box">
            <div class="flex-t">
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("电梯开关门情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('doorOpenCloseSpeed')"
                    >
                      <span>{{ $l("门的开合速度是否正常") }}</span>
                      <el-select
                        v-model="form.doorOpenCloseSpeed"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.doorOpenCloseSpeed)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('doorFullClose')"
                    >
                      <span>{{ $l("门的关闭是否完全") }}</span>
                      <el-select
                        v-model="form.doorFullClose"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.doorFullClose)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="runstatus-section" v-if="isCodeShow('noClamp')">
                      <span>{{ $l("无存在夹人的危险") }}</span>
                      <el-select
                        v-model="form.noClamp"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.noClamp)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("电梯控制面板和按钮操作情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('buttonStatus')"
                    >
                      <span>{{ $l("按钮是否正常") }}</span>
                      <el-select
                        v-model="form.buttonStatus"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.buttonStatus)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('abnormalFloors')"
                    >
                      <span>{{ $l("按钮异常所在楼层") }}</span>
                      <el-input
                        v-model="form.abnormalFloors"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      />
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('towerShow')"
                    >
                      <span>{{ $l("层楼显示是否正常") }}</span>
                      <el-select
                        v-model="form.towerShow"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.towerShow)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("电梯启停情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('levelingStop')"
                    >
                      <span>{{ $l("是否平层停止") }}</span>
                      <el-select
                        v-model="form.levelingStop"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.levelingStop)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('carRunShake')"
                    >
                      <span>{{ $l("轿厢运行不抖动震动") }}</span>
                      <el-select
                        v-model="form.carRunShake"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.carRunShake)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('speedStatus')"
                    >
                      <span>{{ $l("速度是否正常") }}</span>
                      <el-select
                        v-model="form.speedStatus"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.speedStatus)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-b">
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("小区应急救援设施情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('fireAlarmValid')"
                    >
                      <span>{{ $l("火灾报警器是否有效") }}</span>
                      <el-select
                        v-model="form.fireAlarmValid"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.fireAlarmValid)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('escapeRouteStatus')"
                    >
                      <span>{{ $l("紧急疏散通道是否畅通") }}</span>
                      <el-select
                        v-model="form.escapeRouteStatus"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.escapeRouteStatus)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('emergencyAccessRunStatus')"
                    >
                      <span>{{ $l("应急通道设备是否正常运行") }}</span>
                      <el-select
                        v-model="form.emergencyAccessRunStatus"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.emergencyAccessRunStatus)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('cultureRideElevatorNotice')"
                    >
                      <span>{{ $l("文明乘梯告示是否清晰") }}</span>
                      <el-select
                        v-model="form.cultureRideElevatorNotice"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.cultureRideElevatorNotice)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("电梯其他情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div class="runstatus-section" v-if="isCodeShow('runs')">
                      <span>{{ $l("运行次数") }}</span>
                      <el-input
                        v-model="form.runs"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("次") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('runDuration')"
                    >
                      <span>{{ $l("运行时长") }}</span>
                      <el-input
                        v-model="form.runDuration"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("分钟") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('waitTimeMax')"
                    >
                      <span>{{ $l("候梯时长") }}</span>
                      <el-input
                        v-model="form.waitTimeMax"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("秒") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('runMileage')"
                    >
                      <span>{{ $l("运行里程") }}</span>
                      <el-input
                        v-model="form.runMileage"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("米") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('mainDoorSwitchCount')"
                    >
                      <span>{{ $l("主门开关次数") }}</span>
                      <el-input
                        v-model="form.mainDoorSwitchCount"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("次") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('secondDoorSwitchCount')"
                    >
                      <span>{{ $l("副门开关次数") }}</span>
                      <el-input
                        v-model="form.secondDoorSwitchCount"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("次") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('wireropeBucklingCount')"
                    >
                      <span>{{ $l("钢丝绳弯折次数") }}</span>
                      <el-input
                        v-model="form.wireropeBucklingCount"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("次") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('overloadRuns')"
                    >
                      <span>{{ $l("超载运行次数") }}</span>
                      <el-input
                        v-model="form.overloadRuns"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("次") }} </span>
                        </div>
                      </el-input>
                    </div>
                    <!-- <div class="runstatus-section" v-if="isCodeShow('alarmBell')">
                      <span>是否有警铃报警</span>
                      <el-select
                        v-model="form.alarmBell"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.alarmBell)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div> -->
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('powerSupplyStatus')"
                    >
                      <span>{{ $l("正常供电") }} </span>
                      <el-select
                        v-model="form.powerSupplyStatus"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.powerSupplyStatus)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('stopPowerTime')"
                    >
                      <span>{{ $l("停电时间") }} </span>
                      <el-input
                        v-model="form.stopPowerTime"
                        :placeholder="deriveLoading ? '' : $l('请输入')"
                        :readonly="readonly"
                      >
                        <div class="unit" slot="suffix">
                          <span>{{ $l("天") }} </span>
                        </div>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-item-box">
                <div class="report-title">
                  <div class="title-l">
                    <strong>{{ $l("电梯外部安全情况") }}</strong>
                  </div>
                </div>
                <div class="content-box">
                  <div class="condition-box">
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('elevatorAroundClean')"
                    >
                      <span>{{ $l("电梯周围是否干净无异物") }}</span>
                      <el-select
                        v-model="form.elevatorAroundClean"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.elevatorAroundClean)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('pitNoPonding')"
                    >
                      <span>{{ $l("底坑无渗水积水") }}</span>
                      <el-select
                        v-model="form.pitNoPonding"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.pitNoPonding)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('pitLighting')"
                    >
                      <span>{{ $l("底坑照明正常") }}</span>
                      <el-select
                        v-model="form.pitLighting"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.pitLighting)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('hoistwayLighting')"
                    >
                      <span>{{ $l("井道照明正常") }}</span>
                      <el-select
                        v-model="form.hoistwayLighting"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.hoistwayLighting)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('roomEnvironmentGood')"
                    >
                      <span>{{ $l("机房环境是否良好") }}</span>
                      <el-select
                        v-model="form.roomEnvironmentGood"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.roomEnvironmentGood)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('manualDeviceComplete')"
                    >
                      <span>{{ $l("手动紧急装置是否齐全") }}</span>
                      <el-select
                        v-model="form.manualDeviceComplete"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.manualDeviceComplete)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('uncivilizedRideElevator')"
                    >
                      <span>{{ $l("无不文明乘梯行为") }}</span>
                      <el-select
                        v-model="form.uncivilizedRideElevator"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.uncivilizedRideElevator)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="runstatus-section"
                      v-if="isCodeShow('overload')"
                    >
                      <span>{{ $l("未出现超载情况") }}</span>
                      <el-select
                        v-model="form.overload"
                        :placeholder="$l('请选择')"
                        :disabled="readonly"
                        :class="showClass(form.overload)"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.value"
                          v-for="item in whether"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-r">
          <div class="report-item-box">
            <div class="report-title">
              <div class="title-l">
                <strong>{{ $l("电梯内部安全情况") }} </strong>
                <span></span>
              </div>
            </div>
            <div class="content-box">
              <div class="condition-box">
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('carLightingStatus')"
                >
                  <span>{{ $l("轿厢照明") }} </span>
                  <el-select
                    v-model="form.carLightingStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.carLightingStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="runstatus-section" v-if="isCodeShow('fanStatus')">
                  <span>{{ $l("风扇") }} </span>
                  <el-select
                    v-model="form.fanStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.fanStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('lightingStatus')"
                >
                  <span>{{ $l("应急照明") }} </span>
                  <el-select
                    v-model="form.lightingStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.lightingStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('carInnerAlarmDevice')"
                >
                  <span>{{ $l("轿内报警装置") }} </span>
                  <el-select
                    v-model="form.carInnerAlarmDevice"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.carInnerAlarmDevice)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('intercomSystemStatus')"
                >
                  <span>{{ $l("对讲系统是否正常") }} </span>
                  <el-select
                    v-model="form.intercomSystemStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.intercomSystemStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('carOverhaulSwitch')"
                >
                  <span>{{ $l("轿厢检修开关") }} </span>
                  <el-select
                    v-model="form.carOverhaulSwitch"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.carOverhaulSwitch)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="runstatus-section" v-if="isCodeShow('stopDevice')">
                  <span>{{ $l("停止装置是否正常") }} </span>
                  <el-select
                    v-model="form.stopDevice"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.stopDevice)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="runstatus-section" v-if="isCodeShow('fireSwitch')">
                  <span>{{ $l("消防开关") }} </span>
                  <el-select
                    v-model="form.fireSwitch"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.fireSwitch)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('carFloorNonSlip')"
                >
                  <span>{{ $l("轿厢地板是否防滑") }} </span>
                  <el-select
                    v-model="form.carFloorNonSlip"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.carFloorNonSlip)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('maintenanceNotice')"
                >
                  <span>{{ $l("维保告示牌是否清晰") }} </span>
                  <el-select
                    v-model="form.maintenanceNotice"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.maintenanceNotice)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('noReplaceParts')"
                >
                  <span>{{ $l("无待整备配件") }}</span>
                  <el-select
                    v-model="form.noReplaceParts"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.noReplaceParts)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('voltageStatus')"
                >
                  <span>{{ $l("电压是否稳定") }}</span>
                  <el-select
                    v-model="form.voltageStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.voltageStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('currentStatus')"
                >
                  <span>{{ $l("电流是否稳定") }}</span>
                  <el-select
                    v-model="form.currentStatus"
                    :placeholder="$l('请选择')"
                    :disabled="readonly"
                    :class="showClass(form.currentStatus)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.value"
                      v-for="item in whether"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="runstatus-section"
                  v-if="isCodeShow('roomTemperature')"
                >
                  <span>{{ $l("机房最高温度") }}</span>
                  <el-input
                    v-model="form.roomTemperature"
                    :placeholder="deriveLoading ? '' : $l('请输入')"
                    :readonly="readonly"
                  >
                    <div class="unit" slot="suffix">
                      <span>℃</span>
                    </div>
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-bottom-box">
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检拍照情况") }} </strong>
            </div>
            <div class="title-r">
              <div style="display: flex">
                <el-upload
                  multiple
                  action=""
                  v-if="!params.reportId"
                  :limit="6"
                  :show-file-list="false"
                  :http-request="handleUploading"
                  accept="image/*"
                >
                  <el-button type="primary" class="uploading" round
                    >{{ $l("上传") }}
                  </el-button>
                </el-upload>
                <el-button
                  v-else-if="files.length != 0 && !deriveLoading"
                  type="primary"
                  class="download"
                  round
                  @click="clickDownloadImg"
                  >{{ $l("下载") }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <div class="img-item" v-for="(t, i) in files" :key="i">
                <img :src="t.url" />
                <div class="o">
                  <span @click="imgDeleteView(1, i)" v-if="!params.reportId"
                    >{{ $l("删除") }}
                  </span>
                  <span @click="imgDeleteView(0, i)" v-if="!deriveLoading"
                    >{{ $l("预览") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检日志说明") }} </strong>
            </div>
            <div class="title-r">
              <el-button
                type="primary"
                class="clar"
                round
                @click="form.remark = ''"
                v-if="!params.reportId && !deriveLoading"
                >{{ $l("清空") }}
              </el-button>
              <!-- <el-button type="primary" class="download" round>确定</el-button> -->
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <el-input
                v-if="!params.reportId"
                type="textarea"
                maxlength="200"
                resize="none"
                :readonly="readonly"
                v-model="form.remark"
              >
              </el-input>
              <p v-else>{{ form.remark }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="report-item-box" v-if="deriveLoading">
        <div class="report-title">
          <div class="title-l">
            <strong>巡检拍照图片详情</strong>
          </div>
        </div>
        <div class="content-box">
          <div class="bigimg">
            <img :src="t.url" v-for="(t, i) in files" :key="i" />
          </div>
        </div>
      </div>
      <el-image-viewer
        v-if="showViewer"
        :url-list="viewfiles"
        :on-close="closeViewer"
      >
      </el-image-viewer>
    </div>
  </pagefra>
</template>

<script>
import dayjs from "dayjs";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import global from "@/mixins/global.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapGetters } from "vuex";
export default {
  mixins: [global],
  data() {
    return {
      params: {},
      files: [],
      showViewer: false,
      form: {
        files: [],
      },
      loading: false,
      normal: [
        { name: this.$l("正常"), value: 1 },
        { name: this.$l("维修"), value: 2 },
        { name: this.$l("停用"), value: 3 },
        { name: this.$l("待确认"), value: 4 },
      ],
      whether: [
        { name: this.$l("是"), value: true },
        { name: this.$l("否"), value: false },
      ],
      safety: [
        { name: this.$l("安全"), value: 1 },
        { name: this.$l("隐患"), value: 2 },
        { name: this.$l("待确认"), value: 3 },
      ],
      saveLoading: false,
      showDerive: false,
      fields: [],
    };
  },
  components: { ElImageViewer },
  computed: {
    ...mapGetters(["deriveLoading"]),
    viewfiles() {
      return this.files.map((v) => v.url);
    },
    showClass() {
      return (v, r = 0) => {
        return v == r ? "abnormal" : "";
      };
    },
    readonly() {
      return this.params.reportId ? true : false;
    },
    isCodeShow() {
      return (code) => {
        return this.fields.length == 0 ? true : this.fields.includes(code);
      };
    },
  },
  created() {
    const { query } = this.$route;
    this.params = query;
    if (query.confirmTime) {
      this.$route.meta.subtitle = `（${dayjs(query.confirmTime).format(
        "YYYY年M月D日"
      )}）`;
    }
    this.loadFields();
    this.loadReportData();
  },
  methods: {
    /* 加载字段 */
    loadFields() {
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_report_code)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.fields = result.data;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.capt;
        });
    },
    /* 加载字段详情 */
    loadReportData() {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_report_detail, {
          params: {
            reportId: this.params.reportId,
            jobNum: this.params.jobNum,
            confirmTime: this.params.confirmTime,
          },
        })
        .then((response) => {
          let result = response.data;
          console.log(result);
          this.loading = false;
          if (result.code == 0) {
            result.data.files = result.data.files || [];
            result.data.images = result.data.images || [];
            this.form = result.data;
            this.files = result.data.images.map((v) => {
              return {
                url: window.config.baseUrl + "/" + v.imageUrl,
              };
            });
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    /* 图片上传 */
    handleUploading(file) {
      this.files.push({
        file: file.file,
        url: URL.createObjectURL(file.file),
      });
    },
    imgDeleteView(type, index) {
      if (type) {
        this.files.splice(index, 1);
      } else {
        this.showViewer = true;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    /* 保存 */
    handleSaveForm() {
      if (!this.form.adminName) {
        return this.$message(this.$l("请输入电梯管理员！"));
      }
      let no = !this.form.remark;
      this.$confirm(
        no
          ? this.$l("巡检日志说明未填写是否继续提交?")
          : this.$l("确认提交吗?"),
        this.$l("提交日报"),
        {
          type: "warning",
        }
      )
        .then(() => {
          let fileData = new FormData();
          for (const k in this.form) {
            if (!["files", "images"].includes(k) && this.form[k] != null) {
              fileData.append(k, this.form[k]);
            }
          }
          this.files.forEach((v) => {
            fileData.append("files", v.file);
          });
          this.saveLoading = true;
          this.$http
            .post(this.$apiConfig.save_elevator_inspection_report, fileData)
            .then((response) => {
              let result = response.data;
              this.saveLoading = false;
              if (result.code == 0) {
                this.message(result.code, result.msg);
                this.params.reportId = response.data.data;
                sessionStorage.setItem('submit_report_success', 'refresh');
              } else {
                this.message(result.code, result.msg);
              }
            })
            .catch((error) => {
              this.saveLoading = false;
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* a标签下载图片 */
    clickDownloadImg() {
      this.files.forEach((v, i) => {
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/jpg"); // 图片 base64
          const a = document.createElement("a");
          a.download = "巡检图片_" + (i + 1) + ".jpg";
          a.href = url;
          const event = new MouseEvent("click");
          a.dispatchEvent(event);
        };
        image.src =
          v.url +
          (v.url.indexOf("?") > -1 ? "&time=" : "?time=") +
          new Date().valueOf();
      });
    },
    handleDefault() {
      const numCode = [
        "elevatorRunStatus",
        "elevatorInnerStatus",
        "elevatorOuterStatus",
        "estateRescueFacilityStatus",
      ];
      const versaCode = []; //["noClamp", "uncivilizedRideElevator", "overload"];
      const inputCode = [
        "remark",
        "roomTemperature",
        "stopPowerTime",
        "overloadRuns",
        "wireropeBucklingCount",
        "secondDoorSwitchCount",
        "mainDoorSwitchCount",
        "runMileage",
        "waitTimeMax",
        "runDuration",
        "runs",
        "abnormalFloors",
        "adminName",
        "domainName",
        "buildingName",
        "city",
        "elevatorNum",
        "confirmTime",
        "reportId",
        "elevatorType",
        "reportTime",
      ];
      for (const k in this.form) {
        if (this.form[k] == null) {
          this.form[k] = versaCode.includes(k)
            ? false
            : numCode.includes(k)
            ? 1
            : inputCode.includes(k)
            ? ""
            : true;
        }
      }
    },
    /* 导出 */
    handleDerive() {
      this.$store.commit("setDeriveLoading", true);
      this.$nextTick(() => {
        const elementToExport =
          document.getElementsByClassName("pagefra-main")[0];
        elementToExport.style.height =
          112 + document.getElementById("elevator-daily").scrollHeight + "px";
        // elementToExport.style.width = elementToExport.offsetWidth * 2 + 'px'
        // elementToExport.style.height = elementToExport.offsetHeight * 2 + 'px'
        html2canvas(elementToExport, {
          useCORS: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(
              `电梯巡检日报${this.$route.meta.subtitle}_${this.form.registerCode}.pdf`
            );
            elementToExport.style.height = "auto";
            this.$store.commit("setDeriveLoading", false);
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit("setDeriveLoading", false);
            elementToExport.style.height = "auto";
            this.message(500, "导出失败");
          });
      });
    },
  },
};
</script>
<style></style>
<style scoped lang="scss">
.report-box {
  padding: 0 20px;
  background: #f0f1f2;
}

.report-item-box {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;

  .report-title {
    height: 66px;
    padding: 15px 20px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-l {
      color: #5c5c5c;

      strong {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }

  .content-box {
    padding: 15px 20px;

    span,
    label {
      font-size: 14px;
      color: #5c5c5c;
    }
  }
}

.condition-box {
  display: flex;
  flex-wrap: wrap;
}

.runstatus-section {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  /deep/.abnormal {
    .el-select,
    .el-input {
      .el-input__inner {
        color: #ff6969;
      }
    }
  }

  /deep/.el-select,
  /deep/.el-input {
    width: 115px;
    font-size: 14px;
    flex-shrink: 0;
    .el-input__inner {
      font-size: 14px;
      color: #35b6ae;
    }

    .unit {
      display: flex;
      align-items: center;
      height: 100%;
      margin-right: 5px;
    }
  }
}

.info-box {
  display: flex;
  flex-wrap: wrap;

  .code-item {
    width: 25%;
    line-height: 2.5;
  }
}

.runstatus-box {
  display: flex;

  .runstatus-item {
    width: 25%;
  }

  .runstatus-section {
    justify-content: flex-start;
    margin-bottom: 0;
  }
}

.section-box {
  display: flex;

  .section-l {
    flex: 1;

    .flex-box {
      display: flex;
      flex-wrap: wrap;

      .flex-t,
      .flex-b {
        width: 100%;
        display: flex;
      }

      .report-item-box {
        margin-right: 18px;
        flex: 0.3333;
      }
    }
  }

  .section-r {
    width: 25%;
    height: auto;

    .report-item-box {
      height: calc(100% - 18px);
    }
  }
}

.section-bottom-box {
  display: flex;

  & > div {
    &:first-child {
      flex: 1;
      overflow: auto;
    }

    &:last-child {
      width: 50%;
      margin-left: 18px;
    }
  }
}

.uploading {
  background-color: #ff6969;
  border-color: #ff6969;
}

.download {
  margin-left: 20px;
  background-color: #35b6ae;
  border-color: #35b6ae;
}

.clar {
  background-color: #808396;
  border-color: #808396;
}

.explain-box {
  height: auto;
  min-height: 120px;
  display: flex;
  overflow-x: auto;

  /deep/.el-textarea {
    height: 100%;

    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .img-item {
    width: 100px;
    margin-right: 20px;

    img {
      width: 100px;
      height: 100px;
    }

    .o {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5733;
        cursor: pointer;
      }

      span:last-child {
        color: #07a89e;
      }
    }
  }
}

.bigimg {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  img {
    height: 450px;
    width: calc(33.33% - 10px);
    margin-bottom: 20px;
    object-fit: contain;
    object-position: center;
  }

  img:not(:last-child) {
    margin-right: 10px;
  }
}

.ti-input {
  display: flex;
  align-items: center;

  .el-input {
    width: 100px;
  }
}

.back {
  margin-right: 15px;
  cursor: pointer;
}
.bigSize {
  .report-title {
    color: #000;
  }
  .report-item-box .content-box span,
  .report-item-box .content-box label {
    color: #000;
    font-size: 18px;
  }
}
</style>
